<template>
  <label>{{item.value}}</label>
</template>
<script>
import props from './props'
export default {
  name: 'form-item-text',
  mixins: [props],
  data () {
    return {}
  }
}
</script>